<template>
	<div>
		<footer class="footer">
			<div class="wp1200 flex">
				<span>
					&#169; {{ new Date().getFullYear() }}, Episcenter d.o.o. <span class="dot">&#8901;</span>
					<router-link class="txt responsiveNewRow" to="terms-and-conditions">{{ $t("footer.condition") }}</router-link>
					<span class="dot">&#8901;</span>
					<router-link class="txt responsiveNewRow" to="privacy-policy">{{ $t("footer.privacy_policy") }}</router-link>
					<span class="dot">&#8901;</span>
					<router-link class="txt responsiveNewRow" to="cookies">{{ $t("footer.cookies") }}</router-link>
					<span class="dot">&#8901;</span>
					<router-link class="txt responsiveNewRow" to="general-conditions-and-rules-of-participation">{{ $t("awardPage.footer_title") }}</router-link>
					<span class="dot">&#8901;</span>
					<router-link class="txt responsiveNewRow" :to="{ name: 'help-and-support' }">{{ $t("dashboard.help_and_support") }}</router-link>
					<span class="dot">&#8901;</span>
					<router-link class="txt responsiveNewRow" :to="{ name: 'about' }">{{ $t("dashboard.about_panel") }}</router-link>
				</span>
				<div class="flex socials" v-if="showSocials">
					<a target="_blank" href="https://www.facebook.com/people/Episcenter-klub/61559830534494/"><span class="icon warpit_icon_fb_outline"></span></a>
					<a target="_blank" href="https://twitter.com/Episcenter_">
					<span style="position:relative;top:-8px;">
						<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M13.852 17.3903L1.92829 30.9983M27.8406 1.00171L17.2377 13.4886M1 1L24.52 31H31L7.48086 1H1Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</span>
					</a>
					<a target="_blank" href="https://www.linkedin.com/company/episcenter-doo?trk=tyah&trkInfo=tarId%3A1403609188526%2Ctas%3Aepiscenter%2Cidx%3A1-1-1"><span class="warpit_icon_linkedin"></span></a>
					<a target="_blank" href="https://www.instagram.com/episcenterklub"><span class="warpit_icon_instagram_outline"></span></a>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
export default {
	data(){
		return {
			showSocials:true
		}
	},
	mounted() {
		this.checkRouter();
	},
	watch:{
		$route (to){
			if(to.name === 'login'){
				this.showSocials = false;
			} else {
				this.showSocials = true;
			}
		}
	},
	methods: {
		checkRouter(){
				if(this.$route.name === 'login'){
				this.showSocials = false;
			} else {
				this.showSocials = true;
			}
		}
	} 
};
</script>
